<template>
  <div class="box">
    <div class="content-top">
      <div class="content-top-1">
        <div class="title">进度预览</div>
        <div id="chart1" style="width: 35vw;height: 37vh;"></div>
      </div>
       <div class="content-top-2">
        <div class="title">累计产值</div>
        <!-- <div class="content-top-2-total">{{totalValue_view}}万</div> -->
        <el-progress type="circle" style="margin-top:10%" :stroke-width="25" :width="260" :percentage="value"></el-progress>
      </div>
       <div class="content-top-3">
        <div class="title">年度数据统计</div>
        <div class="cont-ec1" id="cont-ec1"></div>
      </div>
    </div>
    <div class="content-box">
      <div class="content-box-top">
         <p style="font-family: SourceHanSansCN-Regular;
            font-size: 16px;
            font-weight: normal;
            letter-spacing: 0em;
            color: #666666;">总产值：<span style="margin-left:3px" v-if="isTotal">{{totalValue_view}}</span><el-input size="mini" v-model="total" v-else style="width:8vw;margin-right:0.5vw;"></el-input> 万</p>
        <div >
          <el-date-picker
            v-model="year"
            size="small"
            @change="doFilter"
            type="year"
            value-format="yyyy"
            placeholder="选择年"
            style="margin:auto;width:170px;font-size:12px;margin-right: 10px"
          ></el-date-picker>
          <span class="button" v-if="totalValue_view" type="success" icon="el-icon-plus" @click="addQin">添加</span>
        </div>
      </div>
        <div class="cont-flex">
          <el-table :data="listData"  style="width: 100%;" height="80vh">
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="100" type="index"></el-table-column>
          <el-table-column label="月份">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-date-picker
                  v-model="master.month"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月">
                </el-date-picker>
              </span>
              <span v-else>{{ scope.row.month }}</span>
            </template>
          </el-table-column>
          <el-table-column label="本月产值（万元）">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-input size="mini" placeholder="请输入内容"  @input="getValue" v-model="master.monthPay"></el-input>
              </span>
              <span v-else>{{ scope.row.monthPay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="累计产值（万元）">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-input size="mini" placeholder="累计产值"   v-model="master.cumulativePay" disabled></el-input>
              </span>
              <span v-else>{{ scope.row.cumulativePay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <span class="table-button" v-if="scope.row.isSet" size="mini" type="primary" @click="pwdChange(scope.row,scope.$index,true)" style="color: #8EA3CE;margin-right: 5px;">保存</span>
                <span class="table-button" v-else type="primary" size="mini" @click="pwdChange(scope.row,scope.$index,true)" style="color: #8EA3CE;margin-right: 5px;margin: 0 8px">修改</span>
                <span class="table-button" v-if="scope.row.isSet" size="mini" @click="pwdChange(scope.row,scope.$index,false)" type="info" style="color: #8EA3CE;margin-right: 5px;">取消</span>
                <span class="table-button button-red" v-else type="danger" size="mini" @click="delChange(scope.row,scope.$index,true)" style="border: 1px solid rgba(236, 15, 15, 0.8);color: #EC0F0F;margin-left: 8px">删除</span>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
  import util from '../../../untils/util'
  import myHttp from '../../../untils/port'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        listData: [],
        groupId: '',
        dataText: '数据加载中...',
        attachmentTypeId: '',
        master: {
          settlementId: '',
          month:'',
          projectId:'',
          contractMoney: '', //合同价款（万元）
          cumulativePay: '',  //累计付款（万元）
          receivingUnit: '',  //累计付款（万元）
          monthFinish: '', //本月完成工程量(%)
          cumulativeFinish: '', // 累计完成工程量(%
          monthPay: '',  //本月付款金额(万元)
          payRate: '',  //付款比率
          remark: '',   // 备注
        },
        isAddFlag: false,
        proType:[],
        type:'',
        chooseDate: util.myTime.getCurTime(),
        projectId:'',
        projectName:'',
        name:'',
        year:'',// 年
        
        joinType:'2',
        projects:[],
        searchPro:[], //搜索的
        total:0,
        isTotal:true,

        totalValue_view:'',
        valueBilv:0,
        value:0,
        pageSize:20,
        pageNum:1,
        tus:0
      }
    },
    mounted() {
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId) {
          this.$store.commit('setGroupId')
          this.groupId = this.$store.state.groupId
        }
        this.getMoney()
    },
    methods: {
      handleSizeChange(val){
        this.pageSize = val
        this.pageNum = 1
        this.getData()
      },
      handleCurrentChange(val){
        this.pageNum = val
        this.getData()
      },
      //年统计图
        echarts2(item1){
          let dataList = [0,0,0,0,0,0,0,0,0,0,0,0]
        item1.forEach((item,index)=>{
          // console.log(item.month.split('-')[1])
          if(item.month.split('-')[1].split('')[0]==0){
            dataList.splice((item.month.split('-')[1].split('')[1])-1,1,item.cumulativePay)
          }
          
        })
            let jidu1 = dataList[0]+dataList[1]+dataList[2]
            let jidu2 = dataList[3]+dataList[4]+dataList[5]
            let jidu3 = dataList[6]+dataList[7]+dataList[8]
            let jidu4 = dataList[9]+dataList[10]+dataList[11]
            let itemSt = [
              {value:jidu1,name:'第一季度'},
              {value:jidu2,name:'第二季度'},
              {value:jidu3,name:'第三季度'},
              {value:jidu4,name:'第四季度'}
            ]
            let chartDom1 = document.getElementById('cont-ec1');
            let myChart1 = this.$echarts.init(chartDom1);
            myChart1.setOption({
                color:['#8394b5','#0d3a95','#4d7bd8','#34579d'],
                series: [
                    {
                      label: {
                show: true,
                position: "inner",
                formatter: "{b}{c}万元",
              },
                    name: 'Nightingale Chart',
                    type: 'pie',
                    radius: [0, '80%'],
                    center: ['50%', '50%'],
                    roseType: 'radius',
                    itemStyle: {
                        borderRadius: 0
                    },
                    data: itemSt
                    }
                ]
            });
        },
      initChart1(item1){
        console.log(item1)
        let dataList = [0,0,0,0,0,0,0,0,0,0,0,0]
        item1.forEach((item,index)=>{
          // console.log(item.month.split('-')[1])
          if(item.month.split('-')[1].split('')[0]==0){
            dataList.splice((item.month.split('-')[1].split('')[1])-1,1,item.monthPay)
          }
          
        })
        console.log(dataList)
        let chart1 = this.$echarts.init(document.querySelector('#chart1'))
        chart1.setOption({
          grid: {
        left: '5%', // 可以决定图形画布距离左侧的位置
        right: '5%', // 可以决定图形画布距离右侧的位置
        bottom: '10%',
        containLabel: true
          },
          width:'94%',
          color:['#4C81EC'],
          xAxis: {
            data: ['1月', '2月', '3月', '4月', '5月', '6月','7月','8月',' 9月','10月','11月','12月',],
             axisLine: {
                            lineStyle: {
                            type: 'solid',
                            color: '',
                            width: '1'
                            }
                        },
                    type: 'category',
                splitLine:{
                            show: true, //让网格显示
                            lineStyle: {//网格样式
                            color:['#07DBFF'], //网格的颜色
                            width:1, //网格的宽度
                            type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                            }
                        },
          },
          yAxis: {
            axisLine: {
                            lineStyle: {
                            type: 'solid',
                            color: '',
                            width: '1'
                            }
                        },
            splitLine:{
                            show: true,
                            lineStyle: {
                            color:['#07DBFF'],
                            width:1,
                            type:'dashed'
                            }
                        },
          },
          toolTip: {

          },
          series: [
            {
              type: 'bar',
              data: dataList,
              barWidth: 10,
              itemStyle:{
                normal:{
                  label:{
                    formatter:function(val){
                      if(val.value!=0){
                        return `${val.name}产值`+'\n'+`${val.value}万元`
                      }
                    },
                  show:true,
                  position:'top',
                  textStyle:{
                    fontWeight:"bolder",
                    fontSize:"12",
                    color:"#2F6CE9e"
                  }
                  }
                }
              }
            }
          ]
        })
      },
    doFilter() {
      this.getData()
    },
    //点击过滤
    showProjectFun(index) {
      this.search.unit = index
      this.getData()
    },
    //获取数据
    getData() {
      var that = this
      myHttp.projectSettlementList({
        projectId:this.groupId,
        year:this.year,
        pageSize:this.pageSize,
        pageNum:this.pageNum
      }).then(function (resp) {
        console.log(resp,'数据展示')
          if (resp.data.code == '200') {
            var list = resp.data.data.projectSettlementList.list || []
            that.total = resp.data.data.projectSettlementList.total
            var bilv = 0
            let yearList = resp.data.data.projectSettlementList.list || []
            let data = []
            that.value = list[0].cumulativePay
            that.value =  Number((that.value/that.totalValue_view*100).toFixed(2))
            console.log(that.value)
            for (var i = 0; i < list.length; i++) {
               list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
               list[i].isSet = false
               if(i==0){
                 bilv = (parseFloat(list[0].cumulativePay)/parseFloat(that.totalValue_view)*100).toFixed(2)
               }
               if(yearList[i].month.split('-')[0]==util.myTime.getYear()){
                data.push(yearList[i])
               }
            }
            if(that.tus==0){
              that.initChart1(data)
            that.echarts2(data)
            that.tus++
            }
            that.valueBilv = bilv
            that.listData = list

            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
            
          } else {
            that.dataText = '暂无数据'
          }
        })
    },

    //获取列表最大时间
    getMonthMax(){
      var result = ''
      if(this.listData.length>0){
        var max = ''
        for(var i=0;i<this.listData.length;i++){
          if(max==''){
            max = this.listData[i].month
          }else{
            if(new Date(max).getTime()<new Date(this.listData[i].months).getTime()){
              max = this.listData[i].month
            }
          }
        }
        var month = new Date(max).getMonth()
        var date = new Date(max).setMonth(month + 1)
        result = util.myTime.getCurMonth(date)
      }
      return result;
    },

    //添加
    addQin() {
      if (this.isAddFlag) {
        this.$message.warning('请先保存当前台账')
        return
      } else if (this.master.settlementId != '') {
        this.$message.warning('请先保存当前编辑项')
        return
      }
      this.isAddFlag = true
      this.master = {
        settlementId: '',
        month:'',
        projectId: '',
        contractMoney: '', //合同价款（万元）
        cumulativePay: '', //累计付款（万元）
        receivingUnit: '', //累计付款（万元）
        monthFinish: '', //本月完成工程量(%)
        cumulativeFinish: '', // 累计完成工程量(%
        monthPay: '0', //本月付款金额(万元)
        payRate: '0', //付款比率
        remark: '', // 备注
        isSet: true,
        totalId:''
      }
      this.master.month =  this.getMonthMax()
     
      this.listData.unshift(this.master)
    },


    //修改
    pwdChange(row, index, cg) {
      //点击修改 判断是否已经保存所有操作
      var that = this

      console.log(1111)
      if (
        (this.master.settlementId != '' &&
          this.master.settlementId != row.settlementId) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
      //}
      //是否是取消操作
      if (!cg) {
        this.getData()
        this.master = {
          settlementId: '',
          month: '',
          projectId: '',
          contractMoney: '', //合同价款（万元）
          cumulativePay: '', //累计付款（万元）
          receivingUnit: '', //累计付款（万元）
          monthFinish: '', //本月完成工程量(%)
          cumulativeFinish: '', // 累计完成工程量(%
          monthPay: '0', //本月付款金额(万元)
          payRate: '0', //付款比率
          remark: '', // 备注
        }
        this.isAddFlag = false
        return (row.isSet = !row.isSet)
      }
      //提交数据
      if (row.isSet) {
        //项目请求操作
        var that = this
        this.master.entId = this.entId
        this.master.projectId = this.groupId
        this.master.totalId = this.totalId
        if (this.master.settlementId == '') {
          myHttp.addProjectSettlement(this.master).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加成功')
              that.isAddFlag = false
              that.getData()
              that.master = {
                id: '',
                settlementId:'',
                contractMoney: '', //合同价款（万元）
                cumulativePay: '', //累计付款（万元）
                receivingUnit: '', //累计付款（万元）
                monthFinish: '', //本月完成工程量(%)
                cumulativeFinish: '', //累计完成工程量(%)
                monthPay: '', //本月付款金额(万元)
                payRate: '', //付款比率
                remark: '', // 备注
              }
              return (row.isSet = !row.isSet)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          // console.log(that.listData)
          myHttp.editProjectSettlement(this.master).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('保存成功')
              that.getData()
              that.isAddFlag = false
              that.master = {
                id: '',
                settlementId:'',
                contractMoney: '', //合同价款（万元）
                cumulativePay: '', //累计付款（万元）
                receivingUnit: '', //累计付款（万元）
                monthFinish: '', //本月完成工程量(%)
                cumulativeFinish: '', //累计完成工程量(%)
                monthPay: '', //本月付款金额(万元)
                payRate: '', //付款比率
                remark: '', // 备注
              }
              return (row.isSet = !row.isSet)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
      } else {
        this.master = {
          settlementId: row.settlementId,
          month: row.month,
          projectId: row.projectId,
          contractMoney: row.contractMoney,
          receivingUnit: row.receivingUnit,
          monthFinish: row.monthFinish,
          cumulativeFinish: row.cumulativeFinish,
          monthPay: row.monthPay,
          payRate: row.payRate,
          remark: row.remark,
        }
        row.isSet = true
      }
    },
    // 删除
    delChange(row, index, cg) {
      var that = this
      if (
        (this.master.settlementId != '' &&
          this.master.settlementId != row.settlementId) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
      this.$confirm('此操作将删除该调数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteProjectSettlement({
              settlementId: row.settlementId,
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch((err) => {})
    },
    watchInput(e){
      this.projectName = e
      this.doFilter()
    },
      // 总产值回显
     getMoney(){
         var that = this
        myHttp.totalInformation({
          projectId: this.groupId,
        }).then(function (resp) {
          if (resp.data.code == '200') {
            if(resp.data.data){
               that.totalValue_view = resp.data.data.totalValue
               that.totalId = resp.data.data.totalId
               that.getData()
            }else{
              that.totalValue_view =''
                  that.totalId = ''
                  that.dataText="暂无数据"
            }
          }
        })
     },
    },
  }
</script>

<style scoped>
.box{
  height: 100%;
  padding: 1vh 1vw;
  overflow: auto;
}
.content-top{
  height: 400px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.content-box{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-box-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 2px solid #E7E7E7;
}
.button{
  display: inline-block;
  width: 60px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: 'SourceHanSansCN-Regular';
  font-size: 14px;
  cursor: pointer;
}
.button-red:hover{
  background-color: #F56C6C;
  color: #fff!important;
}
.title{
  text-align: left;
  padding: 17px 18px;
  font-size: 16px;
  color: #666;
  border-bottom: 2px solid #E7E7E7;
}
.content-top > div{
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-top-2-total{
  background: url('../../../assets/image/background-img.png') 100% 100%;
  width: 276px;
  height:276px;
  margin: 30px auto;
  font-size: 24px;
  color: #5E8EEE;
  line-height: 276px;
}
.content-top-1{
  width: 45%;
}
.content-top-2{
  width: 26%; 
}
.content-top-3{
  width: 28%;
}
.cont-ec1{
  width: 24.4vw;
    height: 36vh;
}
.cont-flex{
  padding: 0 9px;
}
::v-deep .is-leaf .el-table__cell{
  height: 6vh;
}
</style>